module.exports = __webpack_public_path__ + "static/media/img-sort-gray-placeholder.d3f4a7e4.svg";